import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import BannerComponent from '../components/BannerComponent';
import DivContainer from '../components/DivContainer';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import CardService from '../services/CardService';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
class CardRenewDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.state = {
            renewPlastic: false,
            renewAllPlastic: false,
            cardListWithRenewPlastic: this.props.cards.map((c) => {
                return {cardNumber: c.cardNumber, plasticAvailable: c.plasticAvailable, renewPlastic: false};
            }),
        };
        this.renderFooter = this.renderFooter.bind(this);
    }
    getContainerListName() {
        return 'user-card-list-container';
    }

    renderFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => this.props.onHide(undefined)}
                />
                <ActionButton label={t('cards.cardRenewHeader')} variant='button save-button blue' handleClick={this.handleFormSubmit} />
            </div>
        );
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='col-12 change-blocked-dialog-header'>
                    <div colClass='col-12'>
                        <label id={`change-blocked-dialog-header-label-id`}>
                            {this.props.cards.length > 0
                                ? 'Przedłuż ważność kart: '
                                : `${t(`cards.cardRenewHeader`)}: ${this.props.cardNumber}`}
                        </label>
                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }
    setElement() {
        this.initAfterSetElement();
    }
    prepareElement(){
        const list = this.state.cardListWithRenewPlastic;
        const prepared = list?.map(({ plasticAvailable, renewPlastic, cardNumber, ...rest }) => ({
            ...rest,
            card: cardNumber,
            virtualOnly: !renewPlastic // lub jakakolwiek logika
        }));
    return prepared;
    }

    createOrUpdate() {
        const {cardNumber, t} = this.props;
       
        this.scrollToTop();
        if (this.props._isMounted) {
            this.blockUi();
            if (this.props.cards.length === 0) {
                
                this.service
                    .renewCard(cardNumber, !this.state.renewPlastic)
                    .then((response) => {
                        this.showSuccessMessage(t('cards.successRenewCard'));
                        if (this.props.afterSave) {
                            this.props.afterSave(response);
                        } else {
                            this.unblockUi();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(t('cards.errorRenewCard'));
                        this.unblockUi();
                    });
            } else {
                const list = this.prepareElement();
                this.service
                    .renewCards(list)
                    .then((response) => {
                        this.showSuccessMessage(t('cards.successRenewCards'));
                        if (this.props.afterSave) {
                            this.props.afterSave(response);
                        } else {
                            this.unblockUi();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(t('cards.errorRenewCards'));
                        this.unblockUi();
                    });
            }
        }
    }
    returnPlasticColumn(field, rowData, index) {
        
        let { cards } = this.props;
        return (
            rowData.plasticAvailable === true ? (
                <div colClass='row'>
                    <InputCheckboxComponent
                        id={`${rowData[field]}fuelCardPlastic`}
                        name='renewPlastic'
                        label={'Plastikowa'}
                        labelOnRight
                        value={rowData.renewPlastic}
                        onChange={(a, b, c, d, e) => {
                            let karts = cards;
                            karts[index.rowIndex].renewPlastic = c.checked;
                            this.setState({ cardListWithRenewPlastic: karts });
                        }}
                        viewMode='NEW'
                        validators='not_required'
                        colClass='col-12 '
                        valueLabel='label'
                        valueKey='enumValue'
                    />

                </div>
            ) : null
        )
    }
returnVirtualColumn(rowData){
   return(
   
<InputCheckboxComponent
    id={`${rowData.index}fuelCardVirtual`}
    name='fuelCardVirtual'
    label={'Wirtualna'}
    labelOnRight
    value={true}
    viewMode='NEW'
    validators='not_required'
    colClass='col-12'
    disabled={true}
    checked
    valueLabel='label'
    valueKey='enumValue'
/>
    
    
   ) 
}
    selectAllPlasticHeader() {
        const { t } = this.props;
        const plasticExists = this.props.cards?.filter(c => c.plasticAvailable === true).length >0 ;       
        return (
        plasticExists ?     <InputCheckboxComponent
                name='plasticForAll'
                label={t('cards.plasticForAll')}
                //label={"Zaznaczy wszystkie"}
                labelOnRight
                value={this.state.renewAllPlastic}
                viewMode='NEW'
                validators='not_required'
                colClass='col-12'
                onChange={(a, b, c, d, e) => {
                    let newCards = this.props.cards;
                    newCards.forEach((el) => {
                        if (el.plasticAvailable === true) {
                            if (c.checked === true) {
                                el.renewPlastic = c.checked;
                            } else {
                                el.renewPlastic = false;
                            }
                        }

                    });
                    this.setState({ renewAllPlastic: c.checked, cardListWithRenewPlastic: newCards });
                }}

                valueLabel='label'
                valueKey='enumValue'
            /> : null

        )
    }
returnBannerColumn(rowData){
    if (rowData.plasticAvailable === false) {
        return ''; // lub return '';
      }
      return (
        <div className='fleet-good-group-banner-virtual-only-dialog' style={{width:'350px'}}>
          <BannerComponent
            key={'header-banner'}
            subLabel={"Odnawiasz kartę wirtualną działającą w aplikacji MOYA firma. Jeśli potrzebujesz karty plastikowej, zaznacz odpowiedni check-box."}
            iconSvg='ico_blue_banner_icon'
            iconSide='left'
            variant='white-banner'
            rendered={rowData.renewPlastic !== true}
          />
        </div>
      );
   
}
    renderDetails() {
        const {t, listLengthParam} = this.props;

        const text = t('cards.cardRenewListLimitedBanner', { number: listLengthParam });
        return (
            <div className='renew-container'>
                {this.props.listWasLimited ?
                    <div className='fleet-good-group-banner-lpg'>
                        <BannerComponent
                            key={'header-banner'}
                            label={text}
                            subLabel={t('cards.cardRenewListLimitedBannerSublabel')}
                            iconSvg='ico_red_banner_alert_icon'
                            iconSide='left'
                            variant='red-banner'
                        />
                    </div> : null} 
  
                {this.props.cards.length === 0 ? (
                    <>
                                        <div className='row renew-checkboxes'>
                        <div className='col-md-6'>
                            <InputCheckboxComponent
                                name='fuelCardVirtual'
                                label={t('CardType.VIRTUAL')}
                                labelOnRight
                                value={true}
                                viewMode='NEW'
                                validators='not_required'
                                colClass='col-12'
                                disabled={true}
                                checked
                                valueLabel='label'
                                valueKey='enumValue'
                            />
                        </div>
                        <div className='col-md-6'>
                            {/* {this.props.hasPlastic === true ? ( */}
                                <InputCheckboxComponent
                                    name='renewPlastic'
                                    label={t('CardType.PLASTIC')}
                                    labelOnRight
                                    value={this.state.renewPlastic}
                                    stateField={`renewPlastic`}
                                    onChange={(a, b, c, d, e) => {
                                        this.setState({renewPlastic: c.checked});
                                    }}
                                    viewMode='NEW'
                                    validators='not_required'
                                    colClass='col-12 '
                                    valueLabel='label'
                                    valueKey='enumValue'
                                />
                            {/* ) : null}{' '} */}
                        </div>
                    </div>
                        {this.state.renewPlastic === false //&& this.props.hasPlastic === true
                         ?
                            <div className='fleet-good-group-banner-virtual-only-dialog'>
                                <BannerComponent
                                    key={'header-banner'}
                                    subLabel={"Odnawiasz kartę wirtualną działającą w aplikacji MOYA firma. Jeśli potrzebujesz karty plastikowej, zaznacz odpowiedni check-box."}
                                    iconSvg='ico_blue_banner_icon'
                                    iconSide='left'
                                    variant='white-banner'
                                />
                            </div> : null
                        }

                    </>

                ) : (
                    <DivContainer colClass='row'>
                    <DivContainer colClass='row'>
                        <DataTable
                            id='dataTable'
                            key='data-table'
                            emptyMessage={this.translate('list.empty')}
                            className='my-custom-table'
                            responsive
                            value={this.state.cardListWithRenewPlastic}
                            sortOrder={-1}
                            rows={5}
                            paginator
                            //rows={this.props.cards.length}
                            lazy={this.props.lazy}
                            rowClassName={this.props.rowClassName}
                        >
                            <Column  field='cardNumber' header={"Numer karty"} />
                            <Column field='virtual'  body={this.returnVirtualColumn}/>
                            <Column field='plastic'  header={this.selectAllPlasticHeader(this)}  style={{width: '150px'}} body={this.returnPlasticColumn.bind(this, 'cardNumber')} />
                            <Column field='banner'  body={this.returnBannerColumn}/>

                        </DataTable>
                    </DivContainer>
                </DivContainer>
                )}

               

     

                <DivContainer colClass='back-off-row'>
                    <div className='change-blocked-label'>
                        {' '}
                        {this.props.cards.length === 0 ? t(`cards.cardRenewDesc`) : t(`cards.cardListRenewDesc`)}
                    </div>
                </DivContainer>
            </div>
        );
    }
}

CardRenewDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    cardNumber: '',
    cards: [],
    listWasLimited: false,
};

CardRenewDialog.propTypes = {
    currentUser: PropTypes.object,
    viewMode: PropTypes.string,
    onHide: PropTypes.func,
    visible: PropTypes.bool,
    afterSave: PropTypes.func,
    cardNumber: PropTypes.string,
    hasPlastic: PropTypes.bool,
    cards: PropTypes.array,
    listWasLimited: PropTypes.bool,
    listLengthParam: PropTypes.bool
};

export default withTranslation()(CardRenewDialog);
